import { useGetCompanyDataQuery, useGetFranchiseDataQuery } from '../../../../store/api-slices';
import LoadingPage from '../../../../components-library/loading/LoadingPage';
import { useDefaultSlug } from '../../common/selectors/selectors';
import { FC } from 'react';

interface Props {
  children: JSX.Element;
}

const SlugGuard: FC<Props> = ({ children }): JSX.Element => {
  const { slug, hasCompany } = useDefaultSlug();
  const { isFetching } = useGetFranchiseDataQuery(false, { skip: !!slug });
  const { isFetching: isCompanyFetching } = useGetCompanyDataQuery({
    slug,
    hideLoading: true,
  });

  if (!hasCompany) {
    return <LoadingPage />;
  }

  return (
    <>
      {children}
      {isFetching || (isCompanyFetching && <LoadingPage />)}
    </>
  );
};

export default SlugGuard;
